module.exports = __webpack_public_path__ + "static/img/numbers_card_porting.89f6625e.png";